<mojo-modal
  [confirmAction]="getConfirmAction()"
  [disableSave]="isDisableSave()"
>
  <form [formGroup]="form">
    <div class="form-group">
      <div class="text-left mb-3 modal-note-rejected-checkboxes">
        <mojo-checkboxes [(checkboxes)]="reasons">
        </mojo-checkboxes>
      </div>

      <textarea
        *ngIf="isSelected('Other')"
        placeholder="Required: enter comments here"
        class="form-control comments"
        formControlName="comments"
      ></textarea>
    </div>
  </form>
</mojo-modal>
